module.exports = wp["components"];